module.exports = __webpack_public_path__ + "img/webpack.81da10d7.png";